import React from "react";
import { links } from "../../data/links/links.data";
import { CustomLinkContainer } from "../../components/custom-link-container/custom-link-container.component";

export const HomePage: React.FC = () => {
    return (
        <div className="homepage">
            <div className="homepage-header">
                <img src="images/logo.png" alt="Mount Olympus Logo" className="homepage-logo" />
                <h1 className="homepage-title">Mount Olympus</h1>
            </div>

            <div className="homepage-links">
                {links.map((l, i) => (
                    <CustomLinkContainer link={l} key={i} />
                ))}
            </div>
        </div>
    );
};
